import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { DatePicker, Select } from "antd";
import { Spinner } from "react-bootstrap";
import Axios from "axios";
import { useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import TableComponent from "../../../../_metronic/table/TableComponent";
import FreeDetailsModal from "./FreeDetailsModal";
import DetailsModal from "./DetailsModal";

const { Option } = Select;
const { RangePicker } = DatePicker;

const _init = {
  type: "",
  start_date: "",
  end_date: "",
  store_id: null,
};

const FreeProduct = () => {
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState(false);
  const [productId, setProductId] = useState();
  const [orderId, setOrderId] = useState();
  const [values, setValues] = useState();
  const [list, setList] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  // Validation schema
  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Type is required"),
    start_date: Yup.string().required("date is required"),
    end_date: Yup.string().required("date is required"),
  });

  const data = React.useMemo(() => entities, [entities]);
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: (row, index) => (
          <div className="d-flex align-items-center pl-4">
            <div>
              <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
                {index + 1}
              </h4>
            </div>
          </div>
        ),
        minWidth: 50,
        width: 50,
      },
      {
        Header: "product code",
        accessor: "product_code",
        paddingLeft: "0px",
      },
      {
        Header: "product name",
        accessor: "product_name",
        paddingLeft: "0px",
      },
      {
        Header: "category name",
        accessor: "category_name",
        paddingLeft: "0px",
      },
      {
        Header: "total qty",
        accessor: "totalQty",
        paddingLeft: "0px",
      },
      {
        Header: "total discount",
        accessor: "totalDiscount",
        paddingLeft: "0px",
      },
      {
        Header: "totalVat",
        accessor: "totalVat",
        paddingLeft: "0px",
      },
      {
        Header: "total Price Excluding Vat",
        accessor: "totalPriceExcludingVat",
        paddingLeft: "0px",
      },
      {
        Header: "Action",
        paddingLeft: "0px",
        width: 160,
        minWidth: 160,
        Cell: ({ row }) => (
          <>
            <button
              onClick={() => {
                // setSelectedData(row.original);
                setProductId(row?.original?.product_id);
                setShowDetails(true);
              }}
              className="btn btn-primary mr-2"
            >
              <i className="fas fa-eye p-0 m-0" />
            </button>
          </>
        ),
      },
    ],
    [entities]
  );

  // 3- API Get No. of stores
  const getStoreData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/store/list`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setStoreData(data.data);
    }
  };

  const handleSubmitSearch = async (values) => {
    setLoading(true);
    await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/freeProductReport`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    )
      .then((res) => {
        if (!res.data.error) {
          setEntities(res.data.data);
          const singleData = res.data.data[0];
          const makeHeader = [];
          for (let key in singleData) {
            makeHeader.push({ label: key, key: key });
          }
          setHeaders(makeHeader);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    setLoading(false);
  };

  const getDetails = async () => {
    await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/freeProductInvoiceReport`,
      {
        type: values.type,
        start_date: values.start_date,
        end_date: values.end_date,
        store_id: values.store_id,
        product_id: productId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    )
      .then((res) => {
        if (!res.data.error) {
          setList(res.data?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getStoreData();

    if (productId) {
      getDetails();
    }
  }, [productId]);

  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Free Product Report</h3>
      </div>

      <Formik
        enableReinitialize={true}
        initialValues={_init}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmitSearch(values);
          setValues(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors }) => (
          <div className="card-body">
            <div className="row mb-5">
              <div className="col-md-2">
                <label htmlFor="">Select Type</label>
                <Select
                  className="form-control"
                  placeholder="Select Type"
                  onChange={(value) => setFieldValue("type", value)}
                >
                  <Option value="b2c">B2C</Option>
                  <Option value="b2b">B2B</Option>
                </Select>
                {errors.type && (
                  <div className="is_required">{errors.type}</div>
                )}
              </div>

              <div
                className="col-md-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label htmlFor="">Select Date</label>
                <RangePicker
                  defaultValue={[values.start_date, values.end_date]}
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) => {
                    // handleDateRange(dateString, date)
                    setFieldValue("start_date", dateString[0]);
                    setFieldValue("end_date", dateString[1]);
                  }}
                />
                {errors.start_date && errors.end_date && (
                  <div className="is_required">{errors.start_date}</div>
                )}
              </div>

              <div className="col-md-3 mb-5">
                <label>Select Store</label>
                <Select
                  allowClear
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Select Store"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setFieldValue("store_id", value);
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {storeData &&
                    storeData.map(({ id, name }) => (
                      <Option key={id} value={id}>
                        {name}
                      </Option>
                    ))}
                </Select>
              </div>

              <div className="col-md-2 align-self-center text-left mt-5">
                <button
                  className="btn btn-primary w-50"
                  onClick={() => handleSubmit()}
                  disabled={loading}
                >
                  Search
                  {loading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </button>
              </div>

              <div className="col-md-2 align-self-center text-left mt-5">
                <CSVLink
                  className="btn btn-info"
                  data={entities}
                  headers={headers}
                  filename="free product report"
                >
                  Download Report
                </CSVLink>
              </div>
            </div>
          </div>
        )}
      </Formik>

      {entities?.length > 0 ? (
        <>
          <TableComponent
            data={data}
            columns={columns}
            lists={entities}
            title="free product report list"
            hideAddButton={true}
          />
        </>
      ) : (
        <h2 className="text-center py-5">Please select type and search </h2>
      )}

      {showDetails && (
        <FreeDetailsModal
          setShowDetails={setShowDetails}
          showDetails={showDetails}
          accessToken={accessToken}
          refreshToken={refreshToken}
          entities={list}
          setDetails={setDetails}
          setOrderId={setOrderId}
          setSelectedUser={setSelectedUser}
        />
      )}

      {details && (
        <DetailsModal
          setShowDetails={setDetails}
          showDetails={details}
          accessToken={accessToken}
          refreshToken={refreshToken}
          orderId={orderId}
          selectedUser={selectedUser}
        />
      )}
    </div>
  );
};

export default FreeProduct;
